import React from "react";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import AnimateOnScroll from "../components/AnimateOnScroll";
import Gallery from "../components/gallery";
import ServiceSlider from "../components/ServiceSlider";
import '../styles/services.css'
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Services = () => {
    return (
        <div className="servicesContainer">
            <Navbar/>
            
            <AnimateOnScroll className="serviceCardContainer" animation="animate-right">
                <div className="servicesCard">
                    <div className="servicesCardText">
                        <AnimateOnScroll as="p" className="servicesTitleCard" animation="animate-right" delay={1.5}> 
                            <FontAwesomeIcon icon={faGear} /> Servicios
                        </AnimateOnScroll>
                        <ul>
                            <AnimateOnScroll as="li" animation="animate-right" delay={1.7}> &gt; Fabricación de estructuras y piezas metálicas</AnimateOnScroll>
                            <AnimateOnScroll as="li" animation="animate-right" delay={1.9}>  &gt; Reparación de componentes industriales</AnimateOnScroll>
                            <AnimateOnScroll as="li" animation="animate-right" delay={2.1}> &gt; Trabajo de tornería y fresado</AnimateOnScroll>
                            <AnimateOnScroll as="li" animation="animate-right" delay={2.3}> &gt; Centro Mecanizado</AnimateOnScroll>
                            <AnimateOnScroll as="li" animation="animate-right" delay={2.5}> &gt; Soldadura</AnimateOnScroll>
                        </ul>
                    </div>
                </div>
                
                <ServiceSlider />

            </AnimateOnScroll>

            <Gallery />
            
            <Footer/>
        </div>
    )
};

export default Services;